/* eslint-disable prettier/prettier */
import { useState, useCallback, useEffect } from 'react';
import { dashboardService } from '../services/dashboardService';
import { DashboardData } from '../types/dashboard';

export const useDashboard = () => {
	const [dashboardData, setDashboardData] = useState<DashboardData | null>(
		null
	);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<string | null>(null);

	/**
	 * A memoized function to fetch the dashboard data.
	 * It sets loading and error states, mirroring your reference code's pattern.
	 */
	const fetchDashboardData = useCallback(async () => {
		setIsLoading(true);
		setError(null);
		try {
			const data = await dashboardService.getDashboardSummary();
			setDashboardData(data);
			console.log('Dashboard data fetched:', data);
		} catch (err: any) {
			const errorMessage =
				err instanceof Error
					? err.message
					: 'An unknown error occurred.';
			setError(errorMessage);
		} finally {
			setIsLoading(false);
		}
	}, []);

	// This useEffect runs once when the hook is first used in a component,
	// triggering the initial data fetch.
	useEffect(() => {
		fetchDashboardData();
	}, [fetchDashboardData]);

	// We return the state and the fetch function itself.
	// Returning the function allows the UI to trigger a manual refresh.
	return {
		dashboardData,
		isLoading,
		error,
		refreshDashboard: fetchDashboardData,
	};
};
